import { Injectable } from '@angular/core';
import { ApiService } from '../../../../core/service/api.service';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class StatsConfigService {

    constructor(private api: ApiService) { }

    getStatsConfigs(): Observable<any> {
        return this.api.get('vna/stats-config');
    }

    createStatsConfig(data: Object): Observable<any> {
        return this.api.post('vna/stats-config', data);
    }

    updateStatsConfig(pk: number, data: Object): Observable<any> {
        return this.api.put('vna/stats-config', pk, data);
    }

    deleteStatsConfig(pkConfig: number): Observable<any> {
        return this.api.remove('vna/stats-config', pkConfig);
    }

    toFormData(config: Object): Object {
        var configData = Object.assign({}, config);
        configData['fields'] = configData['config']['fields'].map((value) => { return {'value' : value, 'display' : value } });

        delete configData['config'];
        delete configData['pk'];
        delete configData['bo_user_email'];
        delete configData['portal'];
        delete configData['created_at'];
        delete configData['updated_at'];

        return configData;
    }

    toSendData(formData: Object, portal): Object {
        formData['config'] = { 'fields' : formData['fields'].map((o) => {return o.value }) };
        formData['portal'] = portal;
        delete formData['fields'];

        return formData;
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/analytics/stats/services/stats-config.service.ts